import {Space} from 'antd';
import styled from 'styled-components';
import Empty from '../../../Empty';
import {bordersStyles, typographyStyles} from '../../../../utils/styles';

const StyledBudgetActiveInfoPanel = styled(Space)`
  ${bordersStyles.light};
  background-color: ${props => props.theme.colors.neutral_1};
  padding: 32px;
  width: 100%;

  & > .ant-space-item {
    width: 100%;
    > * {
      width: 100%;
    }
  }

  .ant-space-item {
    display: flex;
  }
`;

const StyledBudgetActiveInfo = styled(Space)`
  width: 100%;

  & > .ant-space-item {
    width: 100%;

    &:first-child {
      ${StyledBudgetActiveInfoPanel} {
        border-top-left-radius: 0;
      }
    }
  }

  .ant-progress,
  .overflow-overbudget-progress {
    height: 15px;
  }

  .ant-progress-outer {
    box-shadow: 0 4px 8px 0 #7A8AFF26 !important;
  }
  .ant-progress-inner {
    border-radius: 100px !important;
  }
`;

const StyledBudgetActiveInfoEmpty = styled(Empty)`
  margin: 80px 0;

  .ant-empty-description {
    & > div {
      max-width: unset;
      margin-bottom: 0;
    }
    h3 {
      ${typographyStyles.heading.h5};
      color: ${props => props.theme.colors.neutral_10};
      margin-bottom: 0;
    }
    p {
      ${typographyStyles.heading.h5_1};
      color: ${props => props.theme.colors.neutral_7};
      margin-bottom: 0;
    }
  }
`;

const StyledBudgetActiveInfoPanelAmount = styled.div`
  ${typographyStyles.heading.h5};
  color: ${props => props.theme.colors.neutral_10};
`;

const StyledBudgetActiveInfoPanelDot = styled.span`
  background-color: ${props => props.color};
  border-radius: 45px;
  box-shadow: 0 4px 8px 0 #7A8AFF26;
  display: inline-block;
  height: 15px;
  width: 20px;
`;

const StyledBudgetActiveInfoPanelTitle = styled.div`
  ${typographyStyles.heading.h5};
  color: ${props => props.theme.colors.neutral_7};
`;

const StyledBudgetActiveInfoPanelHeaderTitle = styled.div`
  ${typographyStyles.heading.h4};
  color: ${props => props.theme.colors.neutral_10};
`;

const StyledBudgetActiveInfoPanelPercentage = styled.div`
  ${typographyStyles.heading.h5};
  background-color: ${props => props.type === 'positive' ? props.theme.colors.functional_success_d : props.theme.colors.danger_100};
  border-radius: 16px;
  color: ${props => props.type === 'positive' ? props.theme.colors.functional_success : props.theme.colors.danger_600};
  line-height: 28px;
  padding: 0 8px;
`;


const StyledBudgetActiveInfoPanelHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: self-start;
  flex-wrap: wrap;

  ${StyledBudgetActiveInfoPanelAmount} {
    ${typographyStyles.heading.h4};
  }

  .positive {
    ${StyledBudgetActiveInfoPanelAmount},
    ${StyledBudgetActiveInfoPanelTitle} {
      color: ${props => props.theme.colors.functional_success};
    }
  }

  .negative {
    ${StyledBudgetActiveInfoPanelAmount},
    ${StyledBudgetActiveInfoPanelTitle} {
      color: ${props => props.theme.colors.functional_danger};
    }
  }
`;

export {
  StyledBudgetActiveInfo,
  StyledBudgetActiveInfoEmpty,
  StyledBudgetActiveInfoPanel,
  StyledBudgetActiveInfoPanelAmount,
  StyledBudgetActiveInfoPanelDot,
  StyledBudgetActiveInfoPanelHeader,
  StyledBudgetActiveInfoPanelHeaderTitle,
  StyledBudgetActiveInfoPanelTitle,
  StyledBudgetActiveInfoPanelPercentage,
}
